import "./profile.scss";
import FacebookTwoToneIcon from "@mui/icons-material/FacebookTwoTone";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import PinterestIcon from "@mui/icons-material/Pinterest";
import TwitterIcon from "@mui/icons-material/Twitter";
import PlaceIcon from "@mui/icons-material/Place";
import LanguageIcon from "@mui/icons-material/Language";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Posts from "../../components/posts/Posts"
import { useContext } from "react";
import { AuthContext } from "../../context/authContext";
import { useLocation } from "react-router-dom";
import Update from "../../components/update/Update";
import { useQuery, useMutation } from "react-query";
import { getProfile } from "../../services/api";
import { useState } from "react";

const Profile = () => {
  const [openUpdate, setOpenUpdate] = useState(false);
  const { currentUser } = useContext(AuthContext);
  const userId = parseInt(useLocation().pathname.split("/")[2]);
  // Fetch the profile information for the current user using api.getProfile
  const { isLoading, error, data: data } = useQuery("user", async () => {
    const res = await getProfile(userId);
    return res.data;
  });

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <div className="profile">
      <div className="images">
        <img
          src="/images/cover_user.jpg"
          alt="Cover"
          className="cover"
        />
        <img
          src={currentUser.profilePic}
          alt="Profile"
          className="profilePic"
        />
      </div>
      <div className="profileContainer">
        <div className="uInfo">
          <div className="center">
          { data.last_name && data.first_name && <span>{data.last_name},{data.first_name}</span>}
            <span>@{currentUser.name}</span>
            <div className="info">
              <div className="item">
               {data.id === currentUser.id  && <button onClick={() => setOpenUpdate(true)}>Update</button>}
              </div>
            </div>
          </div>
          
          <div className="right">
            <EmailOutlinedIcon />
            <MoreVertIcon />
          </div>
        </div>
        <Posts />
      </div>
      {openUpdate && <Update setOpenUpdate={setOpenUpdate} user={data} />}
    </div>
  );
};

export default Profile;
